module.exports = __webpack_public_path__ + "img/news-2.ca9a4b6c.png";